/**
 *
 * @typedef {NumberConstructor | BooleanConstructor | StringConstructor | ObjectConstructor} PropType
 */

/**
 * Creates a required prop object.
 * @param {PropType} type - the type of the prop
 * @returns {{ type: PropType, required: true }}
 */
export const required = (type) => ({ type, required: true });

/**
 * Creates an optional prop object.
 * @template [TDefault = never]
 * @param {PropType} type - the type of the prop
 * @param {TDefault} [defaultValue] - the optional default value
 * @returns {TDefault extends never ? { type: PropType, required: false } : { type: PropType, default: TDefault }}
 */
export const optional = (type, defaultValue) =>
  defaultValue === undefined
    ? { type, required: false }
    : { type, default: defaultValue };

/**
 * Creates a nullable prop object.
 * @param {PropType} type - the type of the prop
 * @returns {{ type: PropType, default: null }}
 */
export const nullable = (type) => optional(type, null);
